import FormControlMUI, { FormControlProps } from '@material-ui/core/FormControl';

export const FormControl: React.FC<FormControlProps> = ({ children, ...rest }) => {
	return <FormControlMUI {...rest}>{children}</FormControlMUI>;
};
